import { Component, ElementRef, inject, ViewChild, HostListener } from '@angular/core';
import { PrintMasterService } from './print-master.service';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Master } from '../GlobalVariables';
import { PrintMaster_ItemLabelRequestDTO, PrintMaster_PurchaseChallanRequestDTO, PrintMaster_SaleChallanRequestDTO, PrintMasterDynamicSQLRequestDTO, PrintMasterSalesInvoiceRequestDTO, PrintMasterSalesQuotationRequestDTO, PrintMaster_SaleReleaseRequestDTO, PrintMaster_JobWorkerOutRequestDTO, PrintMaster_CreditNoteRequestDTO, PrintMaster_DebitNoteRequestDTO, PrintMaster_PurchaseInvoiceRequestDTO, PrintMaster_PurchaseOrderRequestDTO, PrintMaster_PurchaseIndentRequestDTO, PrintMaster_PaySlipRequestDTO, PrintMaster_SalesIndentRequestDTO, PrintMaster_SalesOrderRequestDTO, PrintMaster_ReceiptRequestDTO, PrintMaster_PaymentRequestDTO } from './print-master.interface';
import { UserLoginService } from '../Common/UserLoginService/userlogin.service';
import { WhiteLabelServiceService } from '../AdvERP/companies/white-label/white-label-service.service';
import { DocumentEmailPreviewService } from '../Shared/document-email-preview/document-email-preview.service';
import { TenantPrintNameConfigService } from '../AdvERP/companies/company-valuelist/company-print-name-config/company-print-name-config.service';

@Component({
  selector: 'app-print-form',
  templateUrl: './print-form.component.html',
  styleUrls: ['./print-form.component.css']
})
export class PrintFormComponent {
  printMasterService = inject(PrintMasterService);
  printNameConfigService = inject(TenantPrintNameConfigService);
  titleService = inject(Title);
  sanitizer = inject(DomSanitizer);
  whitelabel = inject(WhiteLabelServiceService);
  User = inject(UserLoginService).User();
  router = inject(Router);
  route = inject(ActivatedRoute);
  documentEmailPreview = inject(DocumentEmailPreviewService);

  MasterId: string | null = null;
  MasterType: string | null = null;
  labeltype: string | null = null;
  labelorpackage: string | null = null;
  companyId: string | null = null;
  skipCount: string | null = null;
  OriginalHtml: any;
  pdfFileName: string = 'document';

  // private readonly docSuffixMap: Record<string, string> = {
  //   saleinvoice:     'SalesInvoice',
  //   salequotation:   'Quotation',
  //   salechallan:     'SaleChallan',
  //   purchasechallan: 'PurchaseChallan',
  //   salerelease:     'SaleRelease',
  //   salesorder: 'SalesOrder',
  //   salesindent: 'SalesIndent',
  //   jobworkerout:    'JobWorkerOut',
  //   creditnote:      'CreditNote',
  //   debitnote:       'DebitNote',
  //   purchaseinvoice: 'PurchaseInvoice',
  //   purchaseorder:   'PurchaseOrder',
  //   purchaseindent:  'PurchaseIndent',
  //   payslip:         'PaySlip',
  //   receipt:         'Receipt',
  //   payment:         'Payment',
  //   label:           'Label',
  // };

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.key.toLowerCase() === 'p') {
      event.preventDefault();
      this.handlePrint();
    }
  }

  @ViewChild('previewFrame', { static: true }) frame!: ElementRef<HTMLIFrameElement>;
  @ViewChild('pdfFrame', { static: false }) pdfFrame!: ElementRef<HTMLIFrameElement>;

  iframeWindow: Window | null = null;
  HtmlData: SafeHtml = '';
  CssData: string = '';
  scriptContent: string = '';

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      params.keys.forEach(key => {
        const lowerKey = key.toLowerCase();
        if (lowerKey === 'masterid') this.MasterId = params.get(key);
        if (lowerKey === 'mastertype') this.MasterType = params.get(key);
        if (lowerKey === 'labeltype') this.labeltype = params.get(key);
        if (lowerKey === 'labelorpackage') this.labelorpackage = params.get(key);
        if (lowerKey === 'companyid') this.companyId = params.get(key);
        if (lowerKey === 'skipcount') this.skipCount = params.get(key);
      });

      this.checkEmailAvailability();

      if (this.MasterId && this.MasterType && isNaN(this.MasterId as any) === false) {
        this.printNameConfigService.TenantPrintNameConfig_GetPrintNameByDocType({
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          docType: this.MasterType,
          masterId: Number(this.MasterId)
        }).subscribe({
          next: (res) => {
            const name = res?.printName?.trim();
            this.pdfFileName = name || 'Print';
            this.titleService.setTitle(this.pdfFileName);
          },
          error: () => {
            this.pdfFileName = 'Print';
            this.titleService.setTitle(this.pdfFileName);
          }
        });

        this.getPrintData(Number(this.MasterId), this.MasterType);
      } else if (isNaN(this.MasterId as any) && this.MasterType) {
        this.pdfFileName = 'Print';
        this.getPrintDataWithMasterType(this.MasterType, this.MasterId);
      }
    });
  }

  handlePrint() {
    this.printIframe();
  }

  /** Email icon: shown when this document type has an email preview enabled for the branch (ObjectConfig). */
  showEmail = false;

  private checkEmailAvailability() {
    this.showEmail = false;
    if ((Number(this.MasterId) || 0) > 0) {
      this.documentEmailPreview.isEnabled(this.MasterType).subscribe(enabled => this.showEmail = enabled);
    }
  }

  handleEmail() {
    if (this.MasterType && (Number(this.MasterId) || 0) > 0) {
      this.documentEmailPreview.open(this.MasterType, Number(this.MasterId));
    }
  }

  handleExcel() {
    // TODO: Implement Excel export functionality
  }
  // handlePDF() {
  //   const iframeDoc = this.frame.nativeElement.contentDocument;
  //   if (!iframeDoc) return;

  //   // Select all properly structured invoice pages
  //   const pages = iframeDoc.querySelectorAll('.page[size="A4"]');
  //   if (!pages.length) {
  //     console.warn('No invoice pages found using .page[size="A4"]');
  //     return;
  //   }

  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const imgWidth = 210; // A4 width in mm
  //   const pageHeight = 297;
  //   let pageIndex = 0;

  //   const renderPage = (pageEl: HTMLElement): Promise<void> => {
  //     return html2canvas(pageEl, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: '#ffffff'
  //     }).then(canvas => {
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //       const imgData = canvas.toDataURL('image/jpeg', 1.0);

  //       if (pageIndex > 0) pdf.addPage();
  //       pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
  //       pageIndex++;
  //     });
  //   };

  //   const renderAllPages = async () => {
  //     for (const page of Array.from(pages)) {
  //       await renderPage(page as HTMLElement);
  //     }
  //     pdf.save('invoice.pdf');
  //   };

  //   renderAllPages();
  // }



  /**
   * PDF = the browser's own print pipeline (vector text, full-resolution
   * images), NOT an html2canvas snapshot. The user picks "Save as PDF" and
   * gets the native file dialog for name + location; the suggested file name
   * is the printed document's title, set here from pdfFileName.
   */
  handlePDF() {
    this.printIframe();
  }

  /** Shared by the Print and PDF actions and by Ctrl+P. */
  private printIframe() {
    const frameEl = this.frame.nativeElement;
    const win = frameEl.contentWindow;
    const doc = frameEl.contentDocument;
    if (!win || !doc) { return; }

    this.iframeWindow = win;

    const name = (this.pdfFileName || 'Print').trim();
    try { doc.title = name; } catch { /* title is only a filename hint */ }
    this.titleService.setTitle(name);

    const fire = () => { win.focus(); win.print(); };

    /* let every image finish decoding first, so nothing prints half-loaded */
    const pending = Array.prototype.slice.call(doc.images || [])
      .filter((img: HTMLImageElement) => !img.complete);
    if (!pending.length) { fire(); return; }

    let left = pending.length;
    let fired = false;
    const go = () => { if (!fired) { fired = true; fire(); } };
    const done = () => { if (--left <= 0) { go(); } };
    pending.forEach((img: HTMLImageElement) => {
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
    setTimeout(go, 5000);   /* never block on a stuck image */
  }




  private waitForImagesToLoad(doc: Document): Promise<void> {
    const images = Array.from(doc.images);
    const promises = images.map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise<void>((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = () => reject(new Error(`Failed to load image: ${img.src}`));
      });
    });
    return Promise.all(promises).then(() => { });
  }

  getPrintData(MasterId: number, MasterType: string) {
    if (MasterType.toLowerCase() === 'saleinvoice') {
      let req: PrintMasterSalesInvoiceRequestDTO = {
        invoiceId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PrintSaleInvoice(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'salequotation') {
      let req: PrintMasterSalesQuotationRequestDTO = {
        quotationId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };

      this.printMasterService.PrintMaster_PrintSaleQuotation(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'salechallan') {
      let req: PrintMaster_SaleChallanRequestDTO = {
        invoiceId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_SaleChallan(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      });

    } else if (MasterType.toLowerCase() === 'purchasechallan') {
      let req: PrintMaster_PurchaseChallanRequestDTO = {
        invoiceId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PurchaseChallan(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'salerelease') {
      let req: PrintMaster_SaleReleaseRequestDTO = {
        releaseId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_SaleRelease(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching sale release print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'jobworkerout') {
      let req: PrintMaster_JobWorkerOutRequestDTO = {
        invoiceId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_JobWorkerOut(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching JobWorkerOut print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'creditnote') {
      let req: PrintMaster_CreditNoteRequestDTO = {
        creditNoteId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_CreditNote(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching CreditNote print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'debitnote') {
      let req: PrintMaster_DebitNoteRequestDTO = {
        debitNoteId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_DebitNote(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching DebitNote print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'purchaseinvoice') {
      let req: PrintMaster_PurchaseInvoiceRequestDTO = {
        invoiceId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PurchaseInvoice(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching PurchaseInvoice print data:', error)
      });
    } else if (MasterType.toLowerCase() === 'purchaseorder') {
      let req: PrintMaster_PurchaseOrderRequestDTO = {
        orderId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PurchaseOrder(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching PurchaseOrder print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'purchaseindent') {
      let req: PrintMaster_PurchaseIndentRequestDTO = {
        indentId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PurchaseIndent(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching PurchaseIndent print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'salesindent') {
      let req: PrintMaster_SalesIndentRequestDTO = {
        indentId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_SalesIndent(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching SalesIndent print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'salesorder') {
      let req: PrintMaster_SalesOrderRequestDTO = {
        orderId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_SalesOrder(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching SalesIndent print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'payslip') {
      let req: PrintMaster_PaySlipRequestDTO = {
        paySlipId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PaySlip(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching payslip print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'receipt') {
      let req: PrintMaster_ReceiptRequestDTO = {
        receiptId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_Receipt(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching Receipt print data:', error)
      });
    }
    else if (MasterType.toLowerCase() === 'payment') {
      let req: PrintMaster_PaymentRequestDTO = {
        paymentId: MasterId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_Payment(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching Payment print data:', error)
      });
    }

    else if (MasterType.toLowerCase() === 'label') {
      let req: PrintMaster_ItemLabelRequestDTO = {
        skipCount: Number(this.skipCount) || 0,
        masterId: Number(this.MasterId) || 0,
        masterType: this.MasterType || '',
        labelType: this.labeltype || '',
        labelOrPackage: this.labelorpackage || '',
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      };
      this.printMasterService.PrintMaster_PrintItemLabel(req).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      });
    }
  }


  getPrintDataWithMasterType(MasterType: string, MasterId: string | null) {
    if (MasterType.toLowerCase() === 'dynamicsql') {

      let localData = MasterId ? localStorage.getItem(MasterId) || '' : '';

      let data: PrintMasterDynamicSQLRequestDTO = {
        dynamicSQL: localData
      }
      this.printMasterService.PrintMaster_PrintDynamicSQL(data).subscribe({
        next: (response) => this.processResponseData(response),
        error: (error) => console.error('Error fetching print data:', error)
      })
    }
  }

  processResponseData(response: { items: any[] }): void {
    let HtmlData = '';
    this.OriginalHtml = '';
    response.items.forEach(item => {
      HtmlData += item.htmlData;
      this.OriginalHtml += item.htmlData;
    });

    this.convertAndReplaceImages(this.OriginalHtml).then(updatedHtml => {
      this.OriginalHtml = updatedHtml;
    });

    const { cleanedHtml, styles, scripts } = this.extractStyleAndScriptTags(HtmlData);
    this.CssData = styles;
    this.scriptContent = scripts;
    this.HtmlData = this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);

    const doc = this.frame.nativeElement.contentDocument!;
    const doc2 = this.pdfFrame.nativeElement.contentDocument!;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>${styles}</style>
        </head>
        <body>
          <div id="invoice-wrapper">
        ${cleanedHtml}
      </div>
          <script>${scripts}</script>
        </body>
      </html>
    `);
    doc.close();

    const cleanedHtml1 = this.extractStyleAndScriptTags(this.OriginalHtml).cleanedHtml;
    const styles1 = this.extractStyleAndScriptTags(this.OriginalHtml).styles;
    const scripts1 = this.extractStyleAndScriptTags(this.OriginalHtml).scripts;

    doc2.open();
    doc2.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>${styles1}</style>
        </head>
        <body>
          ${cleanedHtml1}
          <script>${scripts1}</script>
        </body>
      </html>
    `);
    doc2.close();
  }

  extractStyleAndScriptTags(html: string): { cleanedHtml: string, styles: string, scripts: string } {
    let styles = '';
    let scripts = '';

    html = html.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, (match) => {
      const extracted = match.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
      if (extracted && extracted[1]) styles += extracted[1].trim() + '\n';
      return '';
    });

    html = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, (match) => {
      const extracted = match.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
      if (extracted && extracted[1]) scripts += extracted[1].trim() + '\n';
      return '';
    });

    return { cleanedHtml: html.trim(), styles: styles.trim(), scripts: scripts.trim() };
  }

  async convertAndReplaceImages(html: string): Promise<string> {
    const regex = /https:\/\/erp\.advinsoftwares\.com\/Uploads[^\s"']+/g;
    const matches = html.match(regex);

    if (!matches) return html;

    for (const url of matches) {
      try {
        const base64 = await this.toBase64(url);
        html = html.replaceAll(url, base64);
      } catch (error) {
        console.error(`Failed to fetch image: ${url}`, error);
      }
    }

    return html;
  }

  toBase64(url: string): Promise<string> {
    return fetch(url)
      .then(res => res.blob())
      .then(blob => new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      }));
  }
}